import { getFirebaseAnalytics } from "@/config/firebase";
import { logEvent, setUserId, setUserProperties } from "firebase/analytics";

/**
 * 에러를 Firebase Analytics에 기록한다.
 * analytics가 초기화되지 않은 경우(에뮬레이터 환경 등) 아무 동작도 하지 않는다.
 */
export function trackError(error: unknown, context?: Record<string, string>): void {
  const analytics = getFirebaseAnalytics();
  if (!analytics) return;

  const errorInfo =
    error instanceof Error
      ? { error_name: error.name, error_message: error.message.slice(0, 100) }
      : { error_name: "Unknown", error_message: String(error).slice(0, 100) };

  logEvent(analytics, "app_error", {
    ...errorInfo,
    ...context,
    timestamp: new Date().toISOString(),
  });
}

/**
 * 에러 추적용 사용자 정보를 설정한다.
 * 로그인 성공 후 호출하여 이후 발생하는 에러에 사용자 정보가 포함되도록 한다.
 */
export function setErrorTrackingUser(uid: string, role: string): void {
  const analytics = getFirebaseAnalytics();
  if (!analytics) return;
  setUserId(analytics, uid);
  setUserProperties(analytics, { user_role: role });
}
